import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      meta:{
        title:'首页'
      },
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage/index'], resolve),
          meta: {
            title: '首页',
            isHidden:true,
            level:1,
            keepAlive:true
          }
        }, {
          path: '/news-policy',
          name: 'NewsPolicy',
          meta:{
            level:1,
            title:'新闻政策'
          },
          component: resolve => require(['@/view/NewsPolicy/index'], resolve),
          children: [
            {
              path: '/news-policy',
              redirect: '/news-policy/index',
              
            },
            {
              path: '/news-policy/index',
              name: 'policy',
              component: resolve => require(['@/view/NewsPolicy/policy'], resolve),
              meta: {
                title: '新闻政策'
              }
            },
            {
              path: '/news-policy/detail:args',
              name: 'detail',
              component: resolve => require(['@/view/NewsPolicy/PolicyDetail'], resolve),
              meta: {
                title: '文章详情'
              }
            }
          ]
        }, ,{
          path:'/brand:args',
          name:'Brand',
          component: resolve => require(['@/view/Brand/index'], resolve),
          meta: {
            title: '品牌故事',
            level:1
          },
        },{
          path:'/baike',
          name:'baike',
          component: resolve => require(['@/view/BaikePage/index'], resolve),
          meta:{
            level:1,
            title: '野生菌百科',
          },
          children:[{
            path: '/baike',
            redirect: '/baike/index'
          },
          {
            path: '/baike/index',
            name: 'baike-index',
            component: resolve => require(['@/view/BaikePage/Baike'], resolve),
            meta: {
              title: '野生菌百科',
              level:2
            }
          },{
            path: '/baike/detail:args',
            name: 'baike-detail',
            component: resolve => require(['@/view/BaikePage/Detail'], resolve),
            meta: {
              title: '野生菌详情',
              level:2
            }
          }]
        },{
          path: '/construction:args',
            name: 'construction',
            component: resolve => require(['@/view/Construction/index'], resolve),
            meta: {
              title: '基地介绍',
              level:1
            }
        },{
          path:'/market',
          name:'market',
          component: resolve => require(['@/view/Market/index'], resolve),
          meta:{
            level:1,
            title:'市场行情'
          },
          children:[
            {
              path: '/market',
              redirect: '/market/index'
            },
            {
              path: '/market/index',
              name: 'Market-Index',
              component: resolve => require(['@/view/Market/Market'], resolve),
              meta: {
                title: '市场行情',
                level:2
              }
            },{
              path:'/market/detail:args',
              name:'Market-Detail',
              component: resolve => require(['@/view/Market/Detail'], resolve),
              meta: {
                title: '文章详情',
                level:2
              }
            }
          ]
        },{
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
  
})



// WEBPACK FOOTER //
// ./src/router/index.js